(() => {
  const openExpr = '.mypage-open-js';
  const closeExpr = '.mypage-close-js';

  const init = () => {
    const path = ['customer/mypage/camping/reservation_histories', 'customer/mypage/barbecue/reservation_histories', 'customer/mypage/day_camping/reservation_histories', 'customer/mypage/event/reservation_histories'];
    $(path).each((i, ele) => {
      if (location.href.indexOf(ele) > 0) {
        $('body').
          on('click', openExpr, onClickOpenner).
          on('click', closeExpr, onClickCloser);
        $(closeExpr).trigger('click');
      }
    })
  }

  const onClickOpenner = e => {
    const $element = $(e.currentTarget);
    $element.fadeOut().css('display', 'none');
    $($element.data('target')).fadeIn();
    return false;
  }

  const onClickCloser = e => {
    const $element = $(e.currentTarget);
    $($element.data('target')).fadeOut().css('display', 'none');
    $element.parents('.sub-item').find('.mypage-open-js').fadeIn();
    return false;
  }

  $(init)
})();
